const crpABI = [
    {
        inputs: [],
        name: 'pokeWeights',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];

export default crpABI;
